import React from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import cx from 'classnames';
import { useSelector } from "react-redux";
import { connect } from 'react-redux';
import withStyles from "isomorphic-style-loader/withStyles";
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import ListCoverPhoto from "../../ListCoverPhoto/ListCoverPhoto";
import WishListIcon from "../../WishListIcon/WishListIcon";

import messages from "../../../locale/jsonMessages";
import { formatURL } from "../../../helpers/formatURL";

import startIcon from '/public/SiteIcons/star.svg';
import arrowIcon from '/public/SiteIcons/rentNowArrow.svg';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';

import { InstantBookSvgIcon } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";

import { getDynamicTitle } from "../../../helpers/GetDynamicItemName/getDynamicName";
import cs from '../../../components/commonStyle.css';
import s from '../../Home/HomeSlider/HomeSlider.css';

const CommonListingItems = (props) => {
    const { key, id, basePrice, currency, bookingType, title, carType, transmissionLabel, starRatingValue, isChecked, userId, isViewProfile } = props;
    const { coverPhoto, listPhotos, isEditWishList, dynamicTitle, locale } = props;
    const { formatMessage } = useIntl();
    const account = useSelector((state) => state?.account?.data);
    const currentUser = account?.userId;
    const isWishListIcon = userId === currentUser;

    let dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id });

    return (
        <div>
            <div>
                {
                    !isWishListIcon && <WishListIcon listId={id} key={key} isChecked={isChecked} isEditWishList={isEditWishList} />
                }
                <a href={"/cars/" + formatURL(title) + '-' + id} target={'_blank'} className={cs.textDecorationNone}>
                    <div className={s.boxShadow}>
                        <ListCoverPhoto
                            className={s.HRCar}
                            listPhotos={listPhotos}
                            coverPhoto={coverPhoto}
                            photoType={"x_medium"}
                            bgImage
                        />
                        <div className={s.PerDayWrap}></div>
                        <div className={s.sliderbackground}>
                            <div className={s.listingCardCarTypeAndTransmissionLabelFlexContainer}>
                                <div className={s.textFlow}>
                                    <img src={steeringIcon} className={s.carTypeIcon} />{' '}
                                    <span>{carType}</span>
                                </div>
                                <div className={cx(s.textFlow, s.transmissionLabelText, 'transmissionLabelTextRtl')}>{transmissionLabel}</div>
                            </div>
                            <div className={cx(s.PerDay)}>
                                {
                                    bookingType === "instant" && <InstantBookSvgIcon className={s.instantIcon} />
                                }
                                <CurrencyConverter
                                    amount={basePrice}
                                    from={currency}
                                />
                                <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perNight)}</span>
                            </div>
                            <h3 className={s.titleCss}>{dynamicListTitle || title}</h3>
                            {(!isViewProfile || (isViewProfile && !isWishListIcon)) && <div className={s.HRRight}>
                                {starRatingValue > 0 && (
                                    <div className={cx(s.reviewCss, 'reviewCssSliderRTL')}>
                                        <img src={startIcon} className={cx(s.reviewCssImg, 'reviewCssImgRTL')} />
                                        <span>{starRatingValue}</span>
                                    </div>
                                )}
                                <a className={cx(s.btn, cs.textDecorationNone)} href={"/cars/" + formatURL(title) + '-' + id} target={'_blank'}>
                                    <span className={cs.vtrMiddle}><FormattedMessage {...messages.rentNowText} /></span>
                                    <img src={arrowIcon} className={cx(s.arrowIconCss, 'sliderArrowRTL')} />
                                </a>
                            </div>}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};


const mapState = (state) => ({
    locale: state?.intl?.locale,
    dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

export default (withStyles(cs, s)(connect(mapState)(CommonListingItems)));
